var classes = {"container":"index-module_container__noDE3","town":"index-module_town__2H3jy","date":"index-module_date__Fmf-4","with-spacer":"index-module_with-spacer__UNkQz"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
